/** Todo lo que ha pasado en el portal, en una lista. Es el registro de auditoría interno. */
import { useEffect, useState } from 'react'

import { ErrorDeApi, api } from '../api'
import { Cargando, Error, Vacio } from '../componentes/piezas'
import { usePortal } from '../contexto'
import { fechaYHora } from '../textos'
import type { LineaDeActividad } from '../tipos'

/** El tipo de suceso, para ponerle color: se saca de la frase, que ya viene redactada. */
function tipoDeSuceso(frase: string): string {
  const f = frase.toLowerCase()
  if (/ cre[óo] /.test(f)) return 'crea'
  if (/ coment[óo] /.test(f)) return 'comenta'
  if (/ asign[óo] | quit[óo] .*responsable/.test(f)) return 'asigna'
  if (/ elimin|borr|rechaz|cancel/.test(f)) return 'baja'
  if (/ cambi[óo] /.test(f)) return 'cambia'
  return ''
}

export default function Actividad() {
  const { ruta } = usePortal()
  const [lineas, setLineas] = useState<LineaDeActividad[] | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    api
      .get<LineaDeActividad[]>(`${ruta}/actividad?limite=200`)
      .then(setLineas)
      .catch((e: ErrorDeApi) => setError(e.message))
  }, [ruta])

  return (
    <>
      <header className="cabecera">
        <h1>Actividad</h1>
      </header>
      <div className="contenido">
        {error && <Error>{error}</Error>}
        {!lineas && !error && <Cargando filas={6} />}
        {lineas && lineas.length === 0 && (
          <div className="tarjeta">
            <Vacio titulo="Todavía no ha pasado nada" icono="≡" />
          </div>
        )}
        {lineas && lineas.length > 0 && (
          <div className="tarjeta">
            <div className="tarjeta__cuerpo">
              <ul className="historial">
                {lineas.map((l) => (
                  <li key={l.id} className={`suceso suceso--${tipoDeSuceso(l.frase)}`}>
                    {l.frase}
                    <time dateTime={l.cuando}>{fechaYHora(l.cuando)}</time>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
